import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { useContent } from '../App.jsx';
import { ArrowIcon, MenuIcon } from './Icons.jsx';

const nav = [
  ['Instructors', '/instructors'],
  ['Schedule', '/schedule'],
  ['Location', '/location'],
  ['Pricing', '/pricing'],
  ['Contact', '/contact']
];

export default function Layout() {
  const { content } = useContent();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const onRegistrationPage = location.pathname === '/register';
  const headerOnLight = ['/schedule', '/location', '/pricing', '/contact', '/register'].includes(location.pathname);

  useEffect(() => setMenuOpen(false), [location.pathname]);
  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 24);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <div className="site-shell">
      {content.sections.announcement && (
        <div className="announcement">
          <span className="announcement-dot" />
          <span>{content.event.registrationMessage}</span>
          {!onRegistrationPage && <Link to="/register">Reserve your place <ArrowIcon size={15} /></Link>}
        </div>
      )}
      <header className={`site-header ${headerOnLight ? 'on-light' : ''} ${scrolled ? 'is-scrolled' : ''} ${menuOpen ? 'menu-is-open' : ''}`}>
        <div className="header-inner">
          <Link className="brand" to="/" aria-label="Pocono Workshop home">
            <img src="/media/pocono-logo.png" alt="" />
          </Link>
          <nav className="desktop-nav" aria-label="Main navigation">
            {nav.map(([label, href]) => <NavLink key={href} to={href}>{label}</NavLink>)}
          </nav>
          {onRegistrationPage
            ? <span className="header-register-spacer" aria-hidden="true" />
            : <Link className="button button-small header-register" to="/register">Register <ArrowIcon size={16} /></Link>}
          <button className="menu-button" type="button" onClick={() => setMenuOpen((value) => !value)} aria-expanded={menuOpen} aria-label={menuOpen ? 'Close menu' : 'Open menu'}>
            <MenuIcon open={menuOpen} />
          </button>
        </div>
        <div className={`mobile-menu ${menuOpen ? 'is-open' : ''}`}>
          <nav aria-label="Mobile navigation">
            {nav.map(([label, href], index) => <NavLink key={href} to={href}><span>0{index + 1}</span>{label}</NavLink>)}
            {!onRegistrationPage && <Link className="button" to="/register">Register for {content.event.year} <ArrowIcon /></Link>}
          </nav>
        </div>
      </header>
      <main><Outlet /></main>
      <footer className="site-footer">
        <div className="footer-main">
          <div className="footer-brand">
            <img src="/media/pocono-logo.png" alt="Pocono Workshop" />
            <p>{content.site.tagline}</p>
          </div>
          <div className="footer-column">
            <p className="footer-label">Explore</p>
            {nav.map(([label, href]) => <Link key={href} to={href}>{label}</Link>)}
          </div>
          <div className="footer-column">
            <p className="footer-label">Connect</p>
            <a href={`mailto:${content.site.contactEmail}`}>{content.site.contactEmail}</a>
            <a href={content.site.facebookUrl} target="_blank" rel="noreferrer">Facebook</a>
            <a href={content.site.twitterUrl} target="_blank" rel="noreferrer">X / Twitter</a>
          </div>
          <div className="footer-cta">
            <p className="footer-label">{content.event.displayDate}</p>
            <h2>Come make some music.</h2>
            <Link className="text-link light-link" to="/register">Register now <ArrowIcon /></Link>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Pocono Workshop</span>
          <span>King of Prussia, Pennsylvania</span>
        </div>
      </footer>
    </div>
  );
}
